module.exports = __webpack_public_path__ + "img/0Q3A7268_L_Foamcore.6c2d38bf.jpg";